<template>
  <aside class="flex-shrink-0
   xs:z-20 sm:z-20 md:w-72 lg:w-72 xl:w-72 2xl:w-w-72 bg-white border-r dark:border-blue-800 dark:bg-darker md:block m-0 xs:w-full sm:w-full"
         v-if="showSideBar" ref="sidebar">
    <div class="flex flex-col h-full">
      <div class="md:hidden lg:hidden xl:hidden 2xl:hidden relative mb-8 xs:block sm:block">
        <font-awesome-icon class="absolute right-4 top-2 block text-4xl p-2 text-gray-700 cursor-pointer" @click="exitSidebar" icon="times">

        </font-awesome-icon>
      </div>
      <!-- Sidebar links -->
      <nav aria-label="Main" class="flex-1 px-2 py-4 space-y-2 overflow-y-hidden hover:overflow-y-auto">
        <!-- Dashboards links -->
        <div v-for="(item, index) in menu" :key="index">
          <!-- active & hover classes 'bg-blue-100 dark:bg-blue-600' -->
          <p
              @click="showItem(item)"
              class="flex items-center px-2 py-3 text-gray-500 block transition-colors rounded-md hover:bg-blue-100 "
              :class="item.show ? 'bg-blue-100':''"
              role="button"
              aria-haspopup="true"
          >
                  <span aria-hidden="true">
                    <svg
                        class="w-5 h-5"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                      <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      />
                    </svg>
                  </span>
            <span class="ml-2 text-sm"> {{ item.name }} </span>
            <span class="ml-auto" aria-hidden="true" v-if="item.children">
                    <!-- active class 'rotate-180' -->
                    <svg :class="item.show?'rotate-180':''"
                         class="w-4 h-4 transition-transform transform"
                         xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 24 24"
                         stroke="currentColor"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                    </svg>
                  </span>
          </p>
          <div role="menu" v-if="item.show && item.children" class="mt-2 space-y-2 px-7" aria-label="Dashboards">
            <!-- active & hover classes 'text-gray-700 dark:text-light' -->
            <!-- inActive classes 'text-gray-400 dark:text-gray-400' -->
            <p v-for="(row, key) in item.children" :key="key" @click="go(row)"
                         role="menuitem"
                         class="cursor-pointer block p-2 text-sm text-gray-400 transition-colors duration-200 rounded-md dark:text-gray-400 dark:hover:text-light hover:text-gray-700"
            >
              {{ row.name }}
            </p>
          </div>
        </div>
      </nav>

      <!-- Sidebar footer -->
      <div class="flex-shrink-0 px-2 py-4 space-y-2">
        <button type="button" @click="cerrarSession"
                class="flex items-center justify-center w-full px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-700 focus:ring-offset-1 focus:ring-offset-white dark:focus:ring-offset-dark"
        >
          <span>Cerrar Sesión</span>
        </button>
      </div>
      <div class="flex-shrink-0 px-2 py-4 space-y-2">
        <button type="button" @click="editarPerfil"
                class="flex items-center justify-center w-full px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-700 focus:ring-offset-1 focus:ring-offset-white dark:focus:ring-offset-dark"
        >
          <span>Editar Perfil</span>
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: "asidecomponent",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    menu: []
  }),
  methods: {
    ...mapActions({
      cerrarSession: 'cerrarSession',
      editarPerfil: 'editarPerfil',
      setShowSideBar:'utils/setShowSideBar'
    }),
    showItem(item) {
      if (item.children && item.children.length > 0)
        item.show = !item.show
      else{
        this.$router.push(item.link).catch(err=>{})
        this.exitSidebar()
      }
    },
    go(item){
      this.$router.push(item.link).catch(err=>{})
      this.exitSidebar()
    },
    exitSidebar(){
      this.setShowSideBar(false)
    }

  },
  computed: {
    ...mapGetters({
      showSideBar: 'utils/getShowSideBar',
    })
  },
  mounted() {
    let aux = []
    this.items.forEach(element => {
      element.show = false
      aux.push(Object.assign({}, element))
    })
    this.menu = aux
  }
}
</script>

<style scoped>

</style>